export const navLinks = [
  { label: '首页', href: '/' },
  { label: '热门连载', href: '/category/all' },
  { label: '最新上架', href: '/category/all' },
  { label: '分类浏览', href: '/category/all' },
  { label: '排行榜', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export const popularComics = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '热血',
    rating: 9.7,
    chapterCount: 201,
    status: '连载中',
    coverSeq: 'popular-comic-01',
    coverQuery: 'Stylized digital art cover of a Korean manhwa featuring a dark-haired protagonist with glowing blue eyes standing in a ruined cityscape, cinematic lighting with dramatic shadows, cool blue and deep black tones, painterly style, epic fantasy atmosphere, soft background gradient, professional illustration, vertical composition',
  },
  {
    id: 'comic-2',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: '奇幻',
    rating: 9.8,
    chapterCount: 235,
    status: '连载中',
    coverSeq: 'popular-comic-02',
    coverQuery: 'Vertical Korean webtoon cover art of a mysterious young man wearing a long black coat reading an ancient glowing book, ethereal golden particles floating around, mystical library background with warm amber lighting, fantasy aesthetic, clean composition, soft dreamlike atmosphere, high quality digital painting',
  },
  {
    id: 'comic-3',
    title: '剑尊归来',
    author: 'LICO / Biga',
    category: '武侠',
    rating: 9.6,
    chapterCount: 188,
    status: '连载中',
    coverSeq: 'popular-comic-03',
    coverQuery: 'Korean manhwa cover illustration of a handsome swordsman with flowing dark hair in traditional martial arts robes, cherry blossoms falling around him, misty mountain background with soft pink and sage green tones, wuxia fantasy style, elegant composition, delicate lighting, professional digital art',
  },
  {
    id: 'comic-4',
    title: '恶女是提线木偶',
    author: 'Hanirim / Manggle',
    category: '恋爱',
    rating: 9.5,
    chapterCount: 156,
    status: '连载中',
    coverSeq: 'popular-comic-04',
    coverQuery: 'Vertical elegant Korean romance manhwa cover featuring a beautiful noblewoman in an elaborate Victorian-style dress with golden embroidery, standing in a palace ballroom, soft warm candlelight glow, rose gold and cream tones, romantic fantasy atmosphere, delicate face details, painterly digital illustration',
  },
  {
    id: 'comic-5',
    title: '入赘女婿',
    author: 'Siya / Mang-nan',
    category: '都市',
    rating: 9.3,
    chapterCount: 312,
    status: '连载中',
    coverSeq: 'popular-comic-05',
    coverQuery: 'Korean modern drama manhwa cover art of a confident businessman in a tailored suit standing in front of a glass skyscraper, city lights reflecting in the background, sophisticated urban atmosphere, cool grey and navy tones with warm accent lighting, clean professional style, high quality digital illustration',
  },
  {
    id: 'comic-6',
    title: '女神降临',
    author: 'Yaongyi',
    category: '校园',
    rating: 9.4,
    chapterCount: 267,
    status: '已完结',
    coverSeq: 'popular-comic-06',
    coverQuery: 'Korean beauty romance manhwa cover featuring a stunning young woman with flawless makeup and flowing brown hair, soft pastel pink and peach background with cherry blossom petals, warm gentle lighting, school uniform aesthetic, dreamy romantic atmosphere, clean digital art style',
  },
  {
    id: 'comic-7',
    title: '伯爵家的废物',
    author: 'Yoo Ryeo Han / PAN4',
    category: '奇幻',
    rating: 9.6,
    chapterCount: 198,
    status: '连载中',
    coverSeq: 'popular-comic-07',
    coverQuery: 'Korean fantasy manhwa cover of a young nobleman with silver hair and piercing red eyes holding a magical artifact, dark gothic mansion interior background with candlelight, mysterious royal atmosphere, deep burgundy and charcoal tones, elegant fantasy illustration, rich dramatic lighting',
  },
  {
    id: 'comic-8',
    title: 'SSS级重生猎人',
    author: 'Redice Studio',
    category: '热血',
    rating: 9.5,
    chapterCount: 176,
    status: '连载中',
    coverSeq: 'popular-comic-08',
    coverQuery: 'Korean action manhwa cover art of a fierce hunter wielding dual glowing daggers in a monster-filled dungeon, dynamic action pose, neon blue energy effects, dark cavern background with bioluminescent crystals, cool blue and violet tones, intense cinematic lighting, epic fantasy style digital painting',
  },
];

export const platformFeatures = [
  {
    id: 'feature-1',
    icon: 'ri-book-open-line',
    title: '海量韩漫资源',
    description: '收录超过5000部韩国漫画作品，涵盖热血、恋爱、奇幻、武侠、都市等全品类，每日更新最新章节，满足各类读者的阅读需求。',
  },
  {
    id: 'feature-2',
    icon: 'ri-smartphone-line',
    title: '下拉式流畅阅读',
    description: '专为移动端优化的下拉式阅读体验，无需翻页即可沉浸式浏览，加载速度快，画质高清，带来极致的在线阅读享受。',
  },
  {
    id: 'feature-3',
    icon: 'ri-shield-check-line',
    title: '免费正版授权',
    description: '平台所有漫画内容均获得官方正版授权，无需付费即可畅读全部作品，让每一位韩漫爱好者都能轻松享受优质内容。',
  },
];

export const testimonials = [
  {
    id: 'testimonial-1',
    name: '小雨',
    role: '韩漫深度读者',
    avatarSeq: 'avatar-01',
    avatarQuery: 'Professional portrait photography of a young Chinese woman with warm smile, soft natural lighting, clean beige background, casual style, editorial portrait, friendly approachable expression, warm skin tones, high quality photo',
    text: '这个韩漫网站的阅读体验真的太棒了！下拉式阅读非常流畅，画质也很清晰。种类齐全，我喜欢的作品几乎都能找到，已经推荐给身边所有爱看韩漫的朋友了。',
  },
  {
    id: 'testimonial-2',
    name: '阿杰',
    role: '漫画资深爱好者',
    avatarSeq: 'avatar-02',
    avatarQuery: 'Professional portrait photography of a young Chinese man with gentle expression, soft studio lighting, clean light grey background, modern casual style, editorial portrait, natural confident look, warm tones, high quality photo',
    text: '从初中开始看漫画到现在已经十几年了，这个平台是我用过最舒服的韩漫阅读网站。更新速度快，分类清晰，最重要的是完全免费！强烈推荐给各位漫友。',
  },
  {
    id: 'testimonial-3',
    name: '小琳',
    role: '大学生读者',
    avatarSeq: 'avatar-03',
    avatarQuery: 'Professional portrait photography of a young Chinese female student with bright eyes and natural smile, soft diffused lighting, clean cream background, casual young style, editorial portrait, fresh youthful expression, warm skin tones, high quality photo',
    text: '全知读者视角、我独自升级这些热门韩漫都在这里找到了，而且画质比其他网站好很多！每天晚上睡前都要刷几话，已经成为我的日常习惯了。',
  },
  {
    id: 'testimonial-4',
    name: '大伟',
    role: '韩漫汉化组成员',
    avatarSeq: 'avatar-04',
    avatarQuery: 'Professional portrait photography of a young Chinese man with confident smile, soft studio lighting, clean warm beige background, smart casual style, editorial portrait, friendly enthusiastic expression, warm tones, high quality photo',
    text: '作为汉化圈的一员，这个平台的漫画质量和更新速度让我非常惊喜。正版授权的模式也让人放心，希望平台越来越好，带给大家更多优秀的韩漫作品！',
  },
  {
    id: 'testimonial-5',
    name: '晓晓',
    role: '二次元爱好者',
    avatarSeq: 'avatar-05',
    avatarQuery: 'Professional portrait photography of a young Chinese woman with sweet smile and long dark hair, soft natural window lighting, clean minimalist white background, casual cozy style, editorial portrait, gentle warm expression, natural skin tones, high quality photo',
    text: '女神降临和恶女是提线木偶这两部简直是我的最爱！画风精美到每一帧都可以当壁纸，下拉式阅读体验堪比官方APP，免费的还这么好用真的很少见。',
  },
];

export const categories = [
  { id: 'remen', name: '热门连载', icon: 'ri-fire-line', count: 1280 },
  { id: 'zuixin', name: '最新上架', icon: 'ri-rocket-line', count: 356 },
  { id: 'rexue', name: '热血少年', icon: 'ri-flashlight-line', count: 892 },
  { id: 'lianai', name: '恋爱甜宠', icon: 'ri-heart-line', count: 756 },
  { id: 'qihuan', name: '奇幻冒险', icon: 'ri-magic-line', count: 643 },
  { id: 'wuxia', name: '武侠江湖', icon: 'ri-sword-line', count: 421 },
  { id: 'dushi', name: '都市生活', icon: 'ri-building-line', count: 534 },
  { id: 'xiaoyuan', name: '校园青春', icon: 'ri-school-line', count: 398 },
];

export const rankings = [
  { rank: 1, title: '我独自升级', views: '1.2亿', rating: 9.7, trend: 'up' },
  { rank: 2, title: '全知读者视角', views: '9800万', rating: 9.8, trend: 'up' },
  { rank: 3, title: '剑尊归来', views: '8500万', rating: 9.6, trend: 'up' },
  { rank: 4, title: '女神降临', views: '7800万', rating: 9.4, trend: 'stable' },
  { rank: 5, title: 'SSS级重生猎人', views: '7200万', rating: 9.5, trend: 'up' },
  { rank: 6, title: '恶女是提线木偶', views: '6800万', rating: 9.5, trend: 'up' },
  { rank: 7, title: '伯爵家的废物', views: '6100万', rating: 9.6, trend: 'stable' },
  { rank: 8, title: '入赘女婿', views: '5600万', rating: 9.3, trend: 'down' },
];